export default{
    ADD_MULTIPLE_AUDIENCE(state, payload){
        state[payload.key] = payload.value;
    }
}